/**
 * OrgaCard MWS Recipeshop Services
 * REST Services zum Kauf von Rezepturen aus kostenpflichtigen Katalogen
 *
 * The version of the OpenAPI document: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { RecipeModel } from '../model/recipe-model';
// @ts-ignore
import { RecipearticleCatalogUsageModel } from '../model/recipearticle-catalog-usage-model';
// @ts-ignore
import { RecipebuyingModel } from '../model/recipebuying-model';
// @ts-ignore
import { RecipecatalogModel } from '../model/recipecatalog-model';
// @ts-ignore
import { RecipegroupModel } from '../model/recipegroup-model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class RecipeShopService {

    protected basePath = '/recipeshop';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Verwendung Rezeptartikel By Catalog
     * Verwendung der Rezeptartikel in Katalog-Rezepturen
     * @param recipearticleCatalogUsageModel 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRecipeusage(recipearticleCatalogUsageModel?: RecipearticleCatalogUsageModel, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public getRecipeusage(recipearticleCatalogUsageModel?: RecipearticleCatalogUsageModel, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public getRecipeusage(recipearticleCatalogUsageModel?: RecipearticleCatalogUsageModel, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public getRecipeusage(recipearticleCatalogUsageModel?: RecipearticleCatalogUsageModel, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/rest/recipeshop/recipeusage`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: recipearticleCatalogUsageModel,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param language 
     * @param recipebuyingModel 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipeshopBuy(language: string, recipebuyingModel?: RecipebuyingModel, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<RecipeModel>>;
    public recipeshopBuy(language: string, recipebuyingModel?: RecipebuyingModel, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<RecipeModel>>>;
    public recipeshopBuy(language: string, recipebuyingModel?: RecipebuyingModel, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<RecipeModel>>>;
    public recipeshopBuy(language: string, recipebuyingModel?: RecipebuyingModel, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (language === null || language === undefined) {
            throw new Error('Required parameter language was null or undefined when calling recipeshopBuy.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (language !== undefined && language !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>language, 'language');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/rest/recipeshop/buy`;
        return this.httpClient.request<Array<RecipeModel>>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: recipebuyingModel,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param recipecatalogId 
     * @param costcenterId 
     * @param language 
     * @param filter 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipeshopRecipegroups(recipecatalogId: number, costcenterId: number, language: string, filter: 'ALL' | 'BOUGHT' | 'UNBOUGHT', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<RecipegroupModel>>;
    public recipeshopRecipegroups(recipecatalogId: number, costcenterId: number, language: string, filter: 'ALL' | 'BOUGHT' | 'UNBOUGHT', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<RecipegroupModel>>>;
    public recipeshopRecipegroups(recipecatalogId: number, costcenterId: number, language: string, filter: 'ALL' | 'BOUGHT' | 'UNBOUGHT', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<RecipegroupModel>>>;
    public recipeshopRecipegroups(recipecatalogId: number, costcenterId: number, language: string, filter: 'ALL' | 'BOUGHT' | 'UNBOUGHT', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (recipecatalogId === null || recipecatalogId === undefined) {
            throw new Error('Required parameter recipecatalogId was null or undefined when calling recipeshopRecipegroups.');
        }
        if (costcenterId === null || costcenterId === undefined) {
            throw new Error('Required parameter costcenterId was null or undefined when calling recipeshopRecipegroups.');
        }
        if (language === null || language === undefined) {
            throw new Error('Required parameter language was null or undefined when calling recipeshopRecipegroups.');
        }
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling recipeshopRecipegroups.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (recipecatalogId !== undefined && recipecatalogId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>recipecatalogId, 'recipecatalogId');
        }
        if (costcenterId !== undefined && costcenterId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>costcenterId, 'costcenterId');
        }
        if (language !== undefined && language !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>language, 'language');
        }
        if (filter !== undefined && filter !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>filter, 'filter');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/rest/recipeshop/recipegroups`;
        return this.httpClient.request<Array<RecipegroupModel>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param search 
     * @param recipecatalogId 
     * @param costcenterId 
     * @param language 
     * @param filter 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipeshopRecipegroupsSearch(search: string, recipecatalogId: number, costcenterId: number, language: string, filter: 'ALL' | 'BOUGHT' | 'UNBOUGHT', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<RecipegroupModel>>;
    public recipeshopRecipegroupsSearch(search: string, recipecatalogId: number, costcenterId: number, language: string, filter: 'ALL' | 'BOUGHT' | 'UNBOUGHT', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<RecipegroupModel>>>;
    public recipeshopRecipegroupsSearch(search: string, recipecatalogId: number, costcenterId: number, language: string, filter: 'ALL' | 'BOUGHT' | 'UNBOUGHT', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<RecipegroupModel>>>;
    public recipeshopRecipegroupsSearch(search: string, recipecatalogId: number, costcenterId: number, language: string, filter: 'ALL' | 'BOUGHT' | 'UNBOUGHT', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (search === null || search === undefined) {
            throw new Error('Required parameter search was null or undefined when calling recipeshopRecipegroupsSearch.');
        }
        if (recipecatalogId === null || recipecatalogId === undefined) {
            throw new Error('Required parameter recipecatalogId was null or undefined when calling recipeshopRecipegroupsSearch.');
        }
        if (costcenterId === null || costcenterId === undefined) {
            throw new Error('Required parameter costcenterId was null or undefined when calling recipeshopRecipegroupsSearch.');
        }
        if (language === null || language === undefined) {
            throw new Error('Required parameter language was null or undefined when calling recipeshopRecipegroupsSearch.');
        }
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling recipeshopRecipegroupsSearch.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (search !== undefined && search !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>search, 'search');
        }
        if (recipecatalogId !== undefined && recipecatalogId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>recipecatalogId, 'recipecatalogId');
        }
        if (costcenterId !== undefined && costcenterId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>costcenterId, 'costcenterId');
        }
        if (language !== undefined && language !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>language, 'language');
        }
        if (filter !== undefined && filter !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>filter, 'filter');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/rest/recipeshop/recipegroups/search`;
        return this.httpClient.request<Array<RecipegroupModel>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param recipegroupId 
     * @param recipecatalogId 
     * @param costcenterId 
     * @param language 
     * @param pageNo 
     * @param pageLen 
     * @param filter 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipeshopRecipes(recipegroupId: number, recipecatalogId: number, costcenterId: number, language: string, pageNo: number, pageLen: number, filter: 'ALL' | 'BOUGHT' | 'UNBOUGHT', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<RecipeModel>>;
    public recipeshopRecipes(recipegroupId: number, recipecatalogId: number, costcenterId: number, language: string, pageNo: number, pageLen: number, filter: 'ALL' | 'BOUGHT' | 'UNBOUGHT', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<RecipeModel>>>;
    public recipeshopRecipes(recipegroupId: number, recipecatalogId: number, costcenterId: number, language: string, pageNo: number, pageLen: number, filter: 'ALL' | 'BOUGHT' | 'UNBOUGHT', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<RecipeModel>>>;
    public recipeshopRecipes(recipegroupId: number, recipecatalogId: number, costcenterId: number, language: string, pageNo: number, pageLen: number, filter: 'ALL' | 'BOUGHT' | 'UNBOUGHT', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (recipegroupId === null || recipegroupId === undefined) {
            throw new Error('Required parameter recipegroupId was null or undefined when calling recipeshopRecipes.');
        }
        if (recipecatalogId === null || recipecatalogId === undefined) {
            throw new Error('Required parameter recipecatalogId was null or undefined when calling recipeshopRecipes.');
        }
        if (costcenterId === null || costcenterId === undefined) {
            throw new Error('Required parameter costcenterId was null or undefined when calling recipeshopRecipes.');
        }
        if (language === null || language === undefined) {
            throw new Error('Required parameter language was null or undefined when calling recipeshopRecipes.');
        }
        if (pageNo === null || pageNo === undefined) {
            throw new Error('Required parameter pageNo was null or undefined when calling recipeshopRecipes.');
        }
        if (pageLen === null || pageLen === undefined) {
            throw new Error('Required parameter pageLen was null or undefined when calling recipeshopRecipes.');
        }
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling recipeshopRecipes.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (recipegroupId !== undefined && recipegroupId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>recipegroupId, 'recipegroupId');
        }
        if (recipecatalogId !== undefined && recipecatalogId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>recipecatalogId, 'recipecatalogId');
        }
        if (costcenterId !== undefined && costcenterId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>costcenterId, 'costcenterId');
        }
        if (language !== undefined && language !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>language, 'language');
        }
        if (pageNo !== undefined && pageNo !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pageNo, 'pageNo');
        }
        if (pageLen !== undefined && pageLen !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pageLen, 'pageLen');
        }
        if (filter !== undefined && filter !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>filter, 'filter');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/rest/recipeshop/recipes`;
        return this.httpClient.request<Array<RecipeModel>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param recipeId 
     * @param costcenterId 
     * @param language 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipeshopRecipesByid(recipeId: number, costcenterId: number, language: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<RecipeModel>;
    public recipeshopRecipesByid(recipeId: number, costcenterId: number, language: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<RecipeModel>>;
    public recipeshopRecipesByid(recipeId: number, costcenterId: number, language: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<RecipeModel>>;
    public recipeshopRecipesByid(recipeId: number, costcenterId: number, language: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (recipeId === null || recipeId === undefined) {
            throw new Error('Required parameter recipeId was null or undefined when calling recipeshopRecipesByid.');
        }
        if (costcenterId === null || costcenterId === undefined) {
            throw new Error('Required parameter costcenterId was null or undefined when calling recipeshopRecipesByid.');
        }
        if (language === null || language === undefined) {
            throw new Error('Required parameter language was null or undefined when calling recipeshopRecipesByid.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (recipeId !== undefined && recipeId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>recipeId, 'recipeId');
        }
        if (costcenterId !== undefined && costcenterId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>costcenterId, 'costcenterId');
        }
        if (language !== undefined && language !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>language, 'language');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/rest/recipeshop/recipe/id`;
        return this.httpClient.request<RecipeModel>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param search 
     * @param recipegroupId 
     * @param recipecatalogId 
     * @param costcenterId 
     * @param language 
     * @param pageNo 
     * @param pageLen 
     * @param filter 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipeshopRecipesSearch(search: string, recipegroupId: number, recipecatalogId: number, costcenterId: number, language: string, pageNo: number, pageLen: number, filter: 'ALL' | 'BOUGHT' | 'UNBOUGHT', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<RecipeModel>>;
    public recipeshopRecipesSearch(search: string, recipegroupId: number, recipecatalogId: number, costcenterId: number, language: string, pageNo: number, pageLen: number, filter: 'ALL' | 'BOUGHT' | 'UNBOUGHT', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<RecipeModel>>>;
    public recipeshopRecipesSearch(search: string, recipegroupId: number, recipecatalogId: number, costcenterId: number, language: string, pageNo: number, pageLen: number, filter: 'ALL' | 'BOUGHT' | 'UNBOUGHT', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<RecipeModel>>>;
    public recipeshopRecipesSearch(search: string, recipegroupId: number, recipecatalogId: number, costcenterId: number, language: string, pageNo: number, pageLen: number, filter: 'ALL' | 'BOUGHT' | 'UNBOUGHT', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (search === null || search === undefined) {
            throw new Error('Required parameter search was null or undefined when calling recipeshopRecipesSearch.');
        }
        if (recipegroupId === null || recipegroupId === undefined) {
            throw new Error('Required parameter recipegroupId was null or undefined when calling recipeshopRecipesSearch.');
        }
        if (recipecatalogId === null || recipecatalogId === undefined) {
            throw new Error('Required parameter recipecatalogId was null or undefined when calling recipeshopRecipesSearch.');
        }
        if (costcenterId === null || costcenterId === undefined) {
            throw new Error('Required parameter costcenterId was null or undefined when calling recipeshopRecipesSearch.');
        }
        if (language === null || language === undefined) {
            throw new Error('Required parameter language was null or undefined when calling recipeshopRecipesSearch.');
        }
        if (pageNo === null || pageNo === undefined) {
            throw new Error('Required parameter pageNo was null or undefined when calling recipeshopRecipesSearch.');
        }
        if (pageLen === null || pageLen === undefined) {
            throw new Error('Required parameter pageLen was null or undefined when calling recipeshopRecipesSearch.');
        }
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling recipeshopRecipesSearch.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (search !== undefined && search !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>search, 'search');
        }
        if (recipegroupId !== undefined && recipegroupId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>recipegroupId, 'recipegroupId');
        }
        if (recipecatalogId !== undefined && recipecatalogId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>recipecatalogId, 'recipecatalogId');
        }
        if (costcenterId !== undefined && costcenterId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>costcenterId, 'costcenterId');
        }
        if (language !== undefined && language !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>language, 'language');
        }
        if (pageNo !== undefined && pageNo !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pageNo, 'pageNo');
        }
        if (pageLen !== undefined && pageLen !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pageLen, 'pageLen');
        }
        if (filter !== undefined && filter !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>filter, 'filter');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/rest/recipeshop/recipes/search`;
        return this.httpClient.request<Array<RecipeModel>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param language 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipeshopShopcatalogs(language: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<RecipecatalogModel>>;
    public recipeshopShopcatalogs(language: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<RecipecatalogModel>>>;
    public recipeshopShopcatalogs(language: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<RecipecatalogModel>>>;
    public recipeshopShopcatalogs(language: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (language === null || language === undefined) {
            throw new Error('Required parameter language was null or undefined when calling recipeshopShopcatalogs.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (language !== undefined && language !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>language, 'language');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/rest/recipeshop/catalogs`;
        return this.httpClient.request<Array<RecipecatalogModel>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
